export const Section1 = {
	heading: 'New Hope Network’s Market Integrity Group: Who We Are',
	para1:
		'Today’s CPG companies face a daunting task: ensuring compliance with federal regulations while simultaneously standing out to retailers and consumers alike. Since 1981, exhibitors and retailers have participated in New Hope’s Natural Products Expos as the place to see and be seen in the natural and emerging products space.',
	para2: {
		content1: 'Prior to every Natural Products Expo, the ',
		content2_link: 'New Hope Standards team',
		content3:
			' reviews all product labels and marketing material before approving a company to exhibit. Our ',
		content4_link: 'Standards Program',
		content5:
			' is based on FDA, USDA and FTC regulations and New Hope’s ingredient requirements. Our Standards Specialists help exhibitors achieve compliance with New Hope’s Standards.'
	},
	para3: {
		content1:
			'Having worked with thousands of companies at Natural Product Expos, many of which wanted more comprehensive regulatory support, ',
		content2_link: 'MarketReady Insights',
		content3:
			' was launched to provide further assistance to companies eager for full-service regulatory consulting. MarketReady provides robust review of a company’s labeling, marketing materials, and web pages, tailored to each company’s specific needs. Our MarketReady team is comprised of industry experts who have comprehensive knowledge of federal regulations affecting food, beverage, and supplement companies and are constantly assessing the evolving regulatory landscape.'
	}
};

export const Section2 = {
	heading: 'Introducing Beacon Discovery & MarketReady Verified',
	para1:
		'In addition to our Natural Products Expos, Standards Program and MarketReady Insights, New Hope Network is propelling the industry further with the launch of Beacon Discovery, a digital platform that matches retailers with natural products brands through filtering options not available anywhere else.',
	para2:
		'We are now helping companies that use MarketReady Insights further differentiate themselves through MarketReady Verified. MarketReady Verified is a distinguishing seal companies can use after working with MarketReady Insights and making recommended revisions. Products that are MarketReady Verified will be identified within Beacon so retailers seeking products that are in full compliance with both New Hope Standards and federal regulations can find them easily. These products can be favorited on Beacon Discovery and will automatically appear on the Expo show map, so retailers know just where to go to find them.',
	para3: {
		content1:
			'Having a great product is necessary for any CPG company, but to get placed on grocery shelves and build consumer trust, brands also need to comply with a myriad of federal regulations. MarketReady Insights can help you get there and with MarketReady Verified you’ll stand out from the crowd. Learn more about ',
		content2_link: 'MarketReady Verified',
		content3: ' so you can Be Seen, Be Heard, Be Found, and Be Ready. '
	}
};

export enum Images {
	newhope_standards = 'https://s44021.pcdn.co/wp-content/uploads/2023/07/1581407263339-1665505560396.png',
	market_ready_insights = 'https://s44021.pcdn.co/wp-content/uploads/2023/07/MarketReadyInsights_RGB.png',
	beacon_discovery = 'https://s44021.pcdn.co/wp-content/uploads/2023/07/Beacon-Discovery-Sapphire-Stacked-e1689703735202.png',
	market_ready_verified = 'https://s44021.pcdn.co/wp-content/uploads/2023/07/MarketReadyVerified_RGB.png'
}

export enum Links {
	newhope = 'https://standards.newhope.com/our-team/',
	standards = 'https://standards.newhope.com/overview/',
	market_ready_insights = 'https://store.newhope.com/pages/marketready',
	market_ready_verified = 'https://beacon.newhope.com/marketready-verified/',
	beacon_discovery = 'https://beacon.newhope.com/',
	standard_home = 'https://standards.newhope.com/'
}
